export default "__VITE_ASSET__CciDGvOt__"